export default __webpack_public_path__ + "static/media/icon_finishingtype_Milgrain.62335556.png";